/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ToInputs */

const en_entity_to = /** @type {(inputs: Entity_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const de_entity_to = /** @type {(inputs: Entity_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Entity_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_to = /** @type {((inputs?: Entity_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ToInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_to(inputs)
	return de_entity_to(inputs)
});